const LOGO_URL =
  "https://static.readdy.ai/image/0bfa0af67c6b6be26198661c1a60759c/3d8ce18578c897b8381251a25aef549c.jpeg";

const FOOTER_LINKS = {
  Services: [
    "Residential Cleaning",
    "Commercial Cleaning",
    "Deep Cleaning",
    "Move-In/Out Cleaning",
    "Window Cleaning",
  ],
  Company: [
    "About Us",
    "Our Team",
    "Careers",
    "Blog",
    "FAQ",
    "Privacy Policy",
  ],
};

const CONTACT_INFO = [
  {
    icon: "ri-map-pin-line",
    label: "Location",
    value: "Miami, Florida",
    href: "https://maps.google.com/?q=Miami,FL",
  },
  {
    icon: "ri-phone-line",
    label: "Call Us",
    value: "(786) 295-9104",
    href: "tel:+17862959104",
  },
  {
    icon: "ri-mail-line",
    label: "Email Us",
    value: "zorobabelcs@gmail.com",
    href: "mailto:zorobabelcs@gmail.com",
  },
  {
    icon: "ri-time-line",
    label: "Working Hours",
    value: "Mon – Sat: 7:00 AM – 8:00 PM\nSunday: 9:00 AM – 5:00 PM",
    href: null,
  },
];

export default function Footer() {
  return (
    <footer className="bg-stone-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-stone-200">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl overflow-hidden">
                <img src={LOGO_URL} alt="ZoroBabel Cleaning Services" className="w-full h-full object-cover" />
              </div>
              <span
                className="text-lg font-bold text-gray-900"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                ZoroBabel
              </span>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed">
              Professional cleaning services for homes and businesses in Miami, FL. Trusted by thousands of customers across South Florida.
            </p>
            <div className="flex items-center gap-2.5 mt-6">
              {["facebook-fill", "instagram-line", "twitter-x-fill", "linkedin-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center bg-stone-200 hover:bg-teal-600 hover:text-white text-gray-500 rounded-full transition-colors cursor-pointer"
                >
                  <i className={`ri-${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav Link Columns */}
          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">
                {category}
              </h4>
              <ul className="flex flex-col gap-3">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact Us */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">
              Contact Us
            </h4>
            <ul className="flex flex-col gap-5">
              {CONTACT_INFO.map((item) => (
                <li key={item.label} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-lg shrink-0 mt-0.5">
                    <i className={`${item.icon} text-teal-600 text-sm`} />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-400 mb-0.5">{item.label}</p>
                    {item.href ? (
                      <a
                        href={item.href}
                        rel="nofollow"
                        className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-pre-line leading-snug"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <p className="text-sm text-gray-700 whitespace-pre-line leading-snug">{item.value}</p>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">
            © 2026 ZoroBabel Cleaning Services. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-gray-400 hover:text-teal-600 cursor-pointer">
              Privacy Policy
            </a>
            <span className="text-gray-300">|</span>
            <a href="#" className="text-xs text-gray-400 hover:text-teal-600 cursor-pointer">
              Terms of Service
            </a>
            <span className="text-gray-300">|</span>
            <a href="#" className="text-xs text-gray-400 hover:text-teal-600 cursor-pointer">
              Cookie Policy
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
